(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeRaceController', TypeRaceController);

    TypeRaceController.$inject = ['GenericEntityDatatableService', 'TypeRace', 'CoreService', '$q', '$uibModal',
        'ConfirmationService'];

    function TypeRaceController(GenericEntityDatatableService, TypeRace, CoreService, $q, $uibModal,
                                ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Race',
            newButtonTitle: 'New Race',
            entityClassHumanized: 'TypeRace',
            entityStateName: 'type-race',
            service: TypeRace,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'code',
                    title: 'Code',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Race',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-race/update/type-race-dialog.html',
                controller: 'TypeRaceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-race/update/type-race-dialog.html',
                controller: 'TypeRaceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeRace', function (TypeRace) {
                        return TypeRace.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Race').result.then(function () {
                    TypeRace.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
